import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { ProductsService } from 'src/app/core/services/product-service/product.service';
import { RegAutocompleteModel } from 'src/app/core/models/properties.model';
import { EnvironmentService } from 'src/app/core/enviroment/environment.service';

@Component({
  selector: 'app-product-search',
  templateUrl: './product-search.component.html',
  styleUrls: ['./product-search.component.scss']
})
export class ProductSearchComponent implements OnInit {

  @Input() search = false;
  @Output() mapToggle = new EventEmitter<boolean>();
  orderOpen = false;
  showMap = false;
  order = {value: 'Ordenar', type: 'all'};
  orderList = [
    {value: 'Mais antigos no início', type: 'older'},
    {value: 'Mais recentes no início', type: 'newest'},
    {value: 'Endereço de A-Z', type: 'asc'},
    {value: 'Endereço de Z-A', type: 'desc'},
    {value: 'Nome de A-Z', type: 'ascending_name'},
    {value: 'Nome de Z-A', type: 'descending_name'}
  ];
  properties = [];
  loading = false;
  valueSearchInput = '';
  autocomp = false;
  autocompIdx = -1;
  autoSearchResults: RegAutocompleteModel[] = [];
  links = {
    next: '',
    page_items: null,
    page_number: null,
    total_items: null,
    total_pages: null,
  };
  fetching = false;
  itemsPerPage = 15;
  public featureInputSearch = false;

  constructor(
    private service: ProductsService,
    private environmentService: EnvironmentService
  ) { }

  ngOnInit(): void {
    this.featureInputSearch = this.environmentService.getEnvVar('feature_input_search') === 'true';
    const vh = window.innerHeight;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  checkScroll(): void {
    const bounding = document.getElementById(`last-message`).getBoundingClientRect();
    if (
      bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
      bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    ) {
      this.onPaginate();
    }
  }

  setFilter(item) {
    this.order = item;
    this.orderOpen = false;
    this.searchProduct(1);
  }

  pointerSelection(idx: number): void {
    this.autocompIdx = idx;
  }

  downList(event): void {
    if (this.autocomp === false) {
      return;
    }
    if ((event.keyCode === 40 || event.keyCode === 38 || event.keyCode === 27)) {
      switch (event.keyCode) {
        case 40:
          if (this.autocompIdx < this.autoSearchResults.length - 1) {
            this.autocompIdx += 1;
          }
          break;
        case 38:
          if (this.autocompIdx > 0) {
            this.autocompIdx -= 1;
          }
          break;
        case 27:
          this.autocomp = false;
          this.autocompIdx = -1;
          return;
      }
      this.updateSearchInput();
    }
  }

  patchInputValue(): void {
    this.autocomp = false;
    this.updateSearchInput();
    this.searchProduct(1);
    this.autocompIdx = -1;
  }

  updateSearchInput(): void {
    const processedValue = this.autoSearchResults[this.autocompIdx]['name'].replace(/<strong>/g, '').replace(/<\/strong>/g, '');
    this.valueSearchInput = processedValue;
  }

  searchAutocomplete(event: string | number): void {
    const searchTxt = String(event);
    if (searchTxt.trim().length > 2) {
      this.autoSearchResults = [];
      this.service.autoCompleteByNameOrAddress(searchTxt).subscribe((response: RegAutocompleteModel[]) => {
        this.autoSearchResults = response;
      });
      this.autocomp = true;
    } else {
      this.autocomp = false;
      this.autocompIdx = -1;
    }
  }

  toggleMap() {
    this.showMap = !this.showMap;
    this.mapToggle.emit(this.showMap);
  }

  searchProduct(page: number) {
    if (this.valueSearchInput.length > 2) {
      this.autocomp = false;
      this.loading = true;
      const params = {
        page,
        search: this.valueSearchInput,
        sorting: this.order.type,
        page_items: this.itemsPerPage
      };
      this.service.searchByName(params).subscribe((results: any) => {
        this.properties = results.payload;
        this.links = results.links;
        this.loading = false;
        this.search = true;
      },
      () => {
        this.properties = [];
        this.loading = false;
        this.search = true;
      });
    }
  }

  selectAutocomplete() {
    this.searchProduct(1);
    this.autocomp = false;
    this.autocompIdx = -1;
  }

  onPaginate() {
    if (!this.fetching && (this.links.page_number < this.links.total_pages)) {
      this.fetching = true;
      const params = {
        page: this.links.page_number + 1,
        search: this.valueSearchInput,
        sorting: this.order.type,
        page_items: this.itemsPerPage
      };
      this.service.searchByName(params).subscribe((resp: any) => {
        this.properties = this.properties.concat(resp.payload);
        this.links = resp.links;
        this.fetching = false;
      },
      () => {
        this.fetching = false;
      });
    }
  }

  public openModal() {
  }

}
